export default __webpack_public_path__ + "static/media/trash.84e222c1.svg";